<template>
	<div>
		<div class="top_div">
			<div class="left_div">
				<el-input v-model="input" placeholder="输入文字搜索员工" style="width: 60%;">
					<el-button slot="append" icon="el-icon-search" @click="searchAction"></el-button>
				</el-input>
				<el-select v-model="region" placeholder="全部状态" style="width: 20%;margin-left: 0.625rem;"
				@change="changeState">
					<el-option label="可用" value="1"></el-option>
					<el-option label="停用" value="0"></el-option>
				</el-select>
			</div>
			<el-button type="primary" style="width: 6.25rem;height: 2.8125rem;" @click="addUser">添加成员</el-button>
		</div>
		<el-table :data="userList" height="500" border style="width: 80%;margin: 0 auto;">
			<el-table-column prop="loginName" label="登录名" align="center" width="180">
			</el-table-column>
			<el-table-column prop="realName" label="姓名" align="center" width="180">
			</el-table-column>
			<el-table-column label="状态" align="center" width="120">
				<template slot-scope="scope">
					<span v-if="scope.row.status =='停用'" style="color: red;">{{ scope.row.status }}</span>
					<span v-else>{{ scope.row.status }}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="editClick(scope.row)">编辑</el-button>
					<el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<div class="page_div">
			<el-pagination background layout="prev, pager, next, total" :total="pageInfo.total"
			:current-page="pageInfo.current" :page-size="10" @prev-click="preClick" @next-click="nextClick"></el-pagination>
			<!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="[20, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="400">
			</el-pagination> -->
		</div>

	</div>

</template>

<script>
	export default {
		name: 'alluser',
		props: ['userList', 'pageInfo'],
		data() {
			return {
				input: '',
				region: '',
				// currentPage: 4,
				// pageTotal: 0,
			}
		},

		methods: {
			handleSizeChange(val) {
				console.log(`alluser handleSizeChange 每页 ${val} 条`);
			},

			handleCurrentChange(val) {
				console.log(`alluser handleCurrentChange 当前页: ${val}`);
			},

			addUser() {
				console.log('alluser addUser')
				this.$emit('bindAddUser')
			},

			editClick(row) {
				console.log('alluser editClick row = ', row)
				
				var editInfo = row
				if (editInfo.status === "可用") {
					editInfo.status = '1'
				} else {
					editInfo.status = '0'
				}
				this.$emit('editUser', editInfo)
			},
			
			deleteClick(row) {
				console.log('alluser deleteClick row = ', row)
				this.$emit('deleteUser', row)
			},
			
			preClick(val) {
				console.log('alluser preClick val = ', val)
				this.$emit('pagePre', val)
			},
			
			nextClick(val) {
				console.log('alluser nextClick val = ', val)
				this.$emit('pageNext', val)
			},
			
			changeState(obj) {
				console.log('alluser changeState obj = ', obj, this.region)
				this.$emit('stateAction', this.region, this.input)
			},
			
			searchAction() {
				console.log('alluser searchAction input = ', this.input)
				this.$emit('serchAction', this.region, this.input)
				
			}
		}
	}
</script>

<style scoped="scoped">
	.top_div {
		margin: 0 auto;
		width: 80%;
		display: flex;
		align-items: center;
		height: 3.75rem;
		justify-content: space-between;
		margin-bottom: 1.25rem;
	}

	.left_div {
		width: 80%;
		display: flex;
		justify-content: flex-start;
		/* background-color: yellow; */
	}

	.page_div {
		width: 80%;
		height: 100px;
		/* background-color: orange; */
		margin: 0 auto;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
</style>
